module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/v2.2.2-228.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/v2.2.2.md
// module id = 671
// module chunks = 313